// extracted by mini-css-extract-plugin
module.exports = {"row":"SsTemporaryOff_row__1RVui"};